import styled from "styled-components/macro";
import { media } from "../../utils";

import { Text } from "../common";

export const IlustracaoContempladoSm = styled.svg(() => ({
  marginBottom: "20px",
  [media.lg()]: {
    display: "none",
  },
}));

export const IlustracaoContempladoLg = styled.svg(() => ({
  display: "none",
  [media.lg()]: {
    display: "block",
  },
}));

export const IlustracaoContempladoContent = styled.div(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [media.lg()]: {
    maxWidth: "calc(100% - 375px)",
  },
}));

export const ContentContemplado = styled.div(() => ({
  [media.lg()]: {
    display: "flex",
  },
}));

export const ContentNaoContemplado = styled.div(() => ({
  boxShadow: "0px 8px 12px 0px #2D292629, 0px -2px 2px 0px #2D29260D",
  borderRadius: "16px",
  padding: "20px",
  [media.lg()]: {
    padding: "20px 64px",
  },
}));

export const LabelInputTitulo = styled(Text)`
  margin-bottom: 0;
`;

export const LabelText = styled(Text)`
  display: none;
  ${media.md()} {
    display: block;
  }
`;

export const ConsultaButton = styled.button`
  width: 100%;
`;

export const NumeroTituloText = styled.p`
  margin-bottom: 0;
  margin-top: 16px;
`;

export const LinkGuia = styled.a`
  color: ${({ theme }) => theme.color.brandPrimary.light};
`;

export const StatuContempladoContent = styled.div(() => ({}));

export const StatusContemplacao = styled.div(({ theme, contemplado }) => ({
  width: "100%",
  ...(contemplado
    ? {
        backgroundColor: theme.color.brandPrimary.dark,
        color: theme.color.neutral["08"],
      }
    : {
        [`${StatuContempladoContent}`]: {
          paddingBottom: "0 !important",
        },
      }),
}));
